<template>
  <div class="seckill">
    <p class="seckill__title">{{ $t('seckill_module') }}</p>
    <p class="seckill__subtitle">{{ $t('generally_placed_below_the_menu__this_module_does_not_need_to_preview__to_provide_a_placeholder。') }}</p>
  </div>
</template>

<script>
export default {
  name: 'SeckillPreview'
}
</script>

<style lang="scss" scoped>
.seckill {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  margin: 30px auto;
  background-color: #fff;
  overflow: hidden;
  &__title {
    font-size: 15px;
    text-align: center;
  }
  &__subtitle {
    font-size: 12px;
    color: #999999;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
